<app-error></app-error>
<div [@routeAnimations]="prepareRoute(outlet)" style="height: 100%;">
    <router-outlet #outlet="outlet" (activate)="onActivate($event)"></router-outlet>
</div>
<block-ui></block-ui>
